(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('v5-presale-contact'))customElements.define('v5-presale-contact',class extends HTMLElement{
 async connectedCallback(){
  if(this.ready)return;this.ready=true;
  const params=new URLSearchParams(location.search),handle=params.get('model'),variantId=params.get('variant');
  if(!/^[a-z0-9][a-z0-9-]{0,149}$/.test(handle||'')||!/^\d{6,22}$/.test(variantId||''))return;
  try{
   const root=window.Shopify?.routes?.root||'/';
   const response=await fetch(root+'products/'+encodeURIComponent(handle)+'.js',{signal:AbortSignal.timeout(4000)});
   if(!response.ok)return;
   const product=await response.json();
   const variant=product.variants?.find(v=>String(v.id)===variantId);
   if(!variant||product.handle!==handle)return;
   const productUrl=root+'products/'+encodeURIComponent(product.handle)+'?variant='+variant.id;
   const title=String(product.title||'');
   const image=variant.featured_image?.src||product.featured_image;
   const imageUrl=new URL(image||'',location.origin);
   if(imageUrl.protocol!=='https:')return;
   this.querySelector('[data-presale-model]').textContent=title;
   this.querySelector('[data-presale-variant]').textContent=variant.title==='Default Title'?'':variant.title;
   this.querySelector('[data-presale-back]').href=productUrl;
   const img=this.querySelector('[data-presale-image]');img.src=imageUrl.href;img.alt=title+' — '+variant.title;
   const fields={model:title,variant:variant.title,link:new URL(productUrl,location.origin).href};
   for(const input of this.querySelectorAll('[data-presale-field]')){input.value=fields[input.dataset.presaleField];input.disabled=false;}
   const labels=JSON.parse(this.querySelector('[data-presale-labels]').textContent);
   const optional=document.createElement('details');optional.className='v5-presale-optional';
   const summary=document.createElement('summary');summary.textContent=labels.optional;optional.append(summary);
   for(const id of ['ContactForm-name','ContactForm-phone']){const field=this.querySelector('#'+id)?.closest('.field');if(field)optional.append(field);}
   const body=this.querySelector('#ContactForm-body');
   body.closest('.field').after(optional);
   body.placeholder=labels.question;
   const bodyLabel=this.querySelector('label[for="ContactForm-body"]');if(bodyLabel)bodyLabel.textContent=labels.question;
   const email=this.querySelector('#ContactForm-email');email.required=true;
   document.querySelector('[data-v5-contact-intro]')?.setAttribute('hidden','');
   const heading=this.querySelector('.title-wrapper--no-top-margin');if(heading)heading.hidden=true;
   this.querySelector('[data-v5-presale-context]').hidden=false;
   this.setAttribute('data-presale-ready','');
  }catch{}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v5-main-product"]) return;
  try {
    
if(!customElements.get('v5-version-comparison')) customElements.define('v5-version-comparison',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.trigger=this.querySelector('.v5-compare-trigger');this.dialog=this.querySelector('dialog');
  if(!this.trigger||!this.dialog)return;
  this.trigger.addEventListener('click',()=>{this.dialog.showModal();this.trigger.setAttribute('aria-expanded','true');this.querySelector('[data-compare-close]').focus({preventScroll:true});});
  this.querySelector('[data-compare-close]').addEventListener('click',()=>this.dialog.close());
  this.dialog.addEventListener('close',()=>{this.trigger.setAttribute('aria-expanded','false');this.trigger.focus({preventScroll:true});});
  this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();});
 }
});

  } catch(e) { console.error(e); }
})();
})();
